var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-table',{attrs:{"columns":_vm.data.columns,"dataSource":_vm.dataSource,"height":"notset"}})}
var staticRenderFns = []

export { render, staticRenderFns }